export class NotificationModel {
    public NotificationId: number;
    public CommunityLotId: number;
    public CommunityLotName: string;
    public NotificationMessage: string;
    public NotificationType: number;
    public CreatedBy: string;
    public CreatedOn: Date;
    public CreatedFrom: string;
    public CreatedFor: string;
    public NotificationReferenceId: number;
}

export class DisplayNotificationListModel {
    public CommunityLotId: number;
    public CommunityLotName: string;
    public NotificationModel: Array<NotificationModel> = new Array<NotificationModel>();
}

export class ClearNotificationModel {
    public CommunityLotId: number;
    public NotificationType: number;
}





// WEBPACK FOOTER //
// ./src/app/models/SignalrModel.ts